var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinutes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    transform: "matrix(-1 0 0 1 32 0)",
    fill: "#FFFFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92447 16.6264C9.08634 15.7937 8.66686 14.7024 8.66602 13.611C8.66518 12.5163 9.08466 11.4216 9.92447 10.5855C11.6016 8.9168 14.3215 8.9168 15.9994 10.5855C17.6765 8.9168 20.3965 8.9168 22.0744 10.5855C22.9654 11.4717 23.3832 12.6498 23.3278 13.8096C23.2783 14.8342 22.8605 15.8438 22.0744 16.6264L15.9994 22.6673L9.92447 16.6264Z",
    stroke: "#07133F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 15.334H14.0007L15.334 13.334L16.6673 17.334L18.0007 15.334H18.6673",
    stroke: "#07133F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinutes);
export default __webpack_public_path__ + "static/media/minutes.23a1bae6cb3e2b8c3fe9c07b6268f170.svg";
export { ForwardRef as ReactComponent };